App.QuestionTable = class extends App.DataTable {
  constructor(table, coverage_type_id, policy_year) {
    let $table = $(table)
    const dataSourceUrl = [
      '/rmg/admin/questions/data_table',
        `?coverage_type_id=${coverage_type_id}`,
        `&policy_year=${policy_year}`
    ].join('')

    const columns = [
      {
        sortable: false,
        title: '',
        render: function (data, type, full, meta) {
          return [
            '<input name="questions_to_import[]"',
                   'type="checkbox"',
                   `value='${JSON.stringify(full.section_question_attributes_to_use_when_importing)}'`,
            '/>'
          ].join('')
        }
      },
      { data: "question_content" },
      { data: "tier" },
      { data: "last_edited_at" }
    ]

    super({
      table:            $table,
      dataSourceUrl:    dataSourceUrl,
      columns:          columns,
      noData:           "No questions available for import",
      pageLength:       null,
      searchFilterHtml: {}
    })
  }

  static questionsToImport(table) {
    return $(table).
      find(`input[name="questions_to_import[]"]:checked`).
      map(function () { return $(this).val() }).
      get()
  }

  static removeRowsThatWereJustImported(table) {
    let data_table = $(table).DataTable()

    for (let row of $(table).find(`input[name="questions_to_import[]"]:checked`).
                      map(function () { return $(this).parents("tr") }).
                      get()) {

      data_table.row(row).remove()
    }

    data_table.draw()
  }
}
